export default "__VITE_ASSET__b9033ffc__"